import React from "react";
import PropTypes from "prop-types";
import { withFormsy } from "formsy-react";
import Toggle from "react-toggle";

import { Row, Col } from "react-bootstrap";
import { IoCheckbox, IoCheckboxOutline } from "react-icons/io5";

import "react-toggle/style.css";

const CustomToggle = ({
  name,
  label,
  value,
  required,
  disabled,
  onChange,
  checkedIcon,
  uncheckedIcon,
  columnSize
}) => {
  const fieldLabel = required && !disabled ? `${label} *` : label;

  return (
    <Row className="form-group">
      {label && (
        <Col sm={columnSize || 12}>
          <label
            className={`control-label ${!label ? "hidden" : ""}`}
            htmlFor={name}
            style={{ textTransform: "uppercase" }}
          >
            {fieldLabel}
          </label>
        </Col>
      )}
      <Col sm={columnSize || 12}>
        <Toggle
          onChange={onChange}
          disabled={disabled}
          checked={value}
          value={value?.toString()}
          icons={{
            checked: checkedIcon || <IoCheckbox />,
            unchecked: uncheckedIcon || <IoCheckboxOutline />
          }}
        />
      </Col>
    </Row>
  );
};

CustomToggle.propTypes = {
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  required: PropTypes.bool,
  checkedIcon: PropTypes.object,
  uncheckedIcon: PropTypes.object,
  columnSize: PropTypes.number
};

export default withFormsy(CustomToggle);
